import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-home',
  templateUrl: './icon-home.component.html',
  styleUrls: ['./icon-home.component.scss'],
  standalone: true,
})
export class IconHomeComponent {
  @Input() color = '#B8FF8D';
  @Input() width = '20';
  @Input() height = '20';
  @Input() outline = false;
}
